export default "__VITE_ASSET__BiNR4IS6__"